import React from 'react'
import { ReviewContentBox } from '../../components'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import PropTypes from 'prop-types'

const ReviewContentLayout = props => {
  let chosenChapterIds = new Set(props.selectedChapters.map(c => c))
  const filteredChapters = props.chapters.filter(c =>
    chosenChapterIds.has(c.id)
  )
  const filteredAssessments = props.selectedAssessments.map(
    element => props.assessments[element]
  )

  return (
    <div id="outer_requirements">
      <ReviewContentBox
        title="Required Assessments"
        subtitle={`Students must pass the following assessments with a score of at least ${props.passingScore}%:`}
      >
        {filteredAssessments.map((a, id) => {
          return <div key={id}>{a}</div>
        })}
      </ReviewContentBox>
      <ReviewContentBox
        title="Required Reading"
        subtitle="Students must complete the following reading:"
      >
        {filteredChapters.map(c => (
          <div key={c.id}>{c.title}</div>
        ))}
      </ReviewContentBox>
      <h3 className="review_header">Certificate Description</h3>
      <div className="data_container review_content_container">
        <div>{props.description}</div>
      </div>
    </div>
  )
}

ReviewContentLayout.propTypes = {
  passingScore: PropTypes.string,
  getAssessments: PropTypes.func,
  selectedAssessments: PropTypes.array,
  assessments: PropTypes.object,
  selectedChapters: PropTypes.array,
  chapters: PropTypes.array,
  description: PropTypes.string,
}

const mapStateToProps = state => {
  return {
    passingScore: state.certInfo.passingScore,
    selectedAssessments: state.certInfo.selectedAssessments,
    selectedChapters: state.certInfo.selectedChapters,
    assessments: state.assessments,
    chapters: state.chapters.chapterChoices,
    description: state.certInfo.description,
  }
}

export default withRouter(connect(mapStateToProps)(ReviewContentLayout))
